import {Action, configureStore, ThunkAction} from "@reduxjs/toolkit";
import productSlice from "./reducers";

export const store = configureStore({
    devTools: true,
    reducer: {
        productSlice,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;

